import { hexToRgba } from "./theme.util";

export const PESTheme = {
  fonts: {
    family: { body: "Inter, sans-serif", code: "Roboto Mono, monospace" },
    colours: {
      primary: "#101828",
    },
    size: {
      display: {
        xs: 24,
        sm: 30,
        md: 36,
        lg: 48,
        xl: 60,
        xxl: 72,
      },
      text: {
        xs: 12,
        sm: 14,
        md: 16,
        lg: 18,
        xl: 20,
        xxl: 22,
      },
    },
    lineHeight: {
      display: {
        xs: 32,
        sm: 38,
        md: 44,
        lg: 60,
        xl: 72,
        xxl: 90,
      },
      text: {
        xs: 18,
        sm: 20,
        md: 24,
        lg: 28,
        xl: 30,
        xxl: 34,
      },
    },
    letterSpacing: {
      display: {
        xs: undefined,
        sm: undefined,
        md: -0.02,
        lg: -0.02,
        xl: -0.02,
        xxl: -0.02,
      },
      text: {
        xs: undefined,
        sm: undefined,
        md: undefined,
        lg: undefined,
        xl: undefined,
        xxl: undefined,
      },
    },
    weight: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },
  baseColours: {
    white: "#FFFFFF",
    black: "#000000",
  },
  colours: {
    grey: {
      0: "#FFFFFF",
      25: "#FCFCFD",
      50: "#F9FAFB",
      100: "#F2F4F7",
      200: "#EAECF0",
      300: "#D0D5DD",
      400: "#98A2B3",
      500: "#667085",
      600: "#475467",
      700: "#344054",
      800: "#1D2939",
      900: "#101828",
    },
    primary: {
      0: "#FFFFFF",
      25: "#F7F7FA",
      50: "#f7f7fa",
      100: "#dfdfeb",
      200: "#c3c4da",
      300: "#a1a3c5",
      400: "#8e91ba",
      500: "#7679ab",
      600: "#61659e",
      700: "#4a4e90",
      800: "#3b4087",
      900: "#292d69",
    },
    purple: {
      0: "#FFFFFF",
      25: "#FCFAFF",
      50: "#F9F5FF",
      100: "#F4EBFF",
      200: "#E9D7FE",
      300: "#D6BBFB",
      400: "#B692F6",
      500: "#9E77ED",
      600: "#7F56D9",
      700: "#6941C6",
      800: "#53389E",
      900: "#42307D",
    },
    error: {
      0: "#FFFFFF",
      25: "#FFFBFA",
      50: "#FEF3F2",
      100: "#FEE4E2",
      200: "#FECDCA",
      300: "#FDA29B",
      400: "#F97066",
      500: "#F04438",
      600: "#D92D20",
      700: "#B42318",
      800: "#912018",
      900: "#7A271A",
    },
    warning: {
      0: "#FFFFFF",
      25: "#FFFCF5",
      50: "#FFFAEB",
      100: "#FEF0C7",
      200: "#FEDF89",
      300: "#FEC84B",
      400: "#FDB022",
      500: "#F79009",
      600: "#DC6803",
      700: "#B54708",
      800: "#93370D",
      900: "#7A2E0E",
    },
    success: {
      0: "#FFFFFF",
      25: "#F6FEF9",
      50: "#ECFDF3",
      100: "#D1FADF",
      200: "#A6F4C5",
      300: "#6CE9A6",
      400: "#32D583",
      500: "#12B76A",
      600: "#039855",
      700: "#027A48",
      800: "#05603A",
      900: "#054F31",
    },
    pink: {
      0: "#FFFFFF",
      25: "#FEF6FB",
      50: "#FDF2FA",
      100: "#FCE7F6",
      200: "#FCCEEE",
      300: "#FAA7E0",
      400: "#F670C7",
      500: "#EE46BC",
      600: "#DD2590",
      700: "#C11574",
      800: "#9E165F",
      900: "#851651",
    },
    fuschia: {
      0: "#FFFFFF",
      25: "#FEFAFF",
      50: "#FDF4FF",
      100: "#FBE8FF",
      200: "#F6D0FE",
      300: "#EEAAFD",
      400: "#E478FA",
      500: "#D444F1",
      600: "#BA24D5",
      700: "#9F1AB1",
      800: "#821890",
      900: "#6F1877",
    },
    cyan: {
      0: "#FFFFFF",
      25: "#F5FEFF",
      50: "#ECFDFF",
      100: "#CFF9FE",
      200: "#A5F0FC",
      300: "#67E3F9",
      400: "#22CCEE",
      500: "#06AED4",
      600: "#088AB2",
      700: "#0E7090",
      800: "#155B75",
      900: "#164C63",
    },
    teal: {
      0: "#FFFFFF",
      25: "#F6FEFC",
      50: "#F0FDF9",
      100: "#CCFBEF",
      200: "#99F6E0",
      300: "#5FE9D0",
      400: "#2ED3B7",
      500: "#15B79E",
      600: "#0E9384",
      700: "#107569",
      800: "#125D56",
      900: "#134E48",
    },
    greyBlue: {
      0: "#FFFFFF",
      25: "#FCFCFD",
      50: "#F8F9FC",
      100: "#EAECF5",
      200: "#D5D9EB",
      300: "#B3B8DB",
      400: "#717BBC",
      500: "#4E5BA6",
      600: "#3E4784",
      700: "#363F72",
      800: "#293056",
      900: "#101323",
    },
    darkOrange: {
      0: "#FFFFFF",
      25: "#FFF9F5",
      50: "#FFF4ED",
      100: "#FFE6D5",
      200: "#FFD6AE",
      300: "#FF9C66",
      400: "#FF692E",
      500: "#FF4405",
      600: "#E62E05",
      700: "#BC1B06",
      800: "#97180C",
      900: "#771A0D",
    },
    utility: {
      0: "#f5f5f5",
      25: "#f5f5f5",
      50: "#f5f5f5",
      100: "#f5f5f5",
      200: "#f5f5f5",
      300: "#f5f5f5",
      400: "#f5f5f5",
      500: "#f5f5f5",
      600: "#f5f5f5",
      700: "#f5f5f5",
      800: "#f5f5f5",
      900: "#f5f5f5",
    },
  },
  gradient: (from: string, to: string, angle: number) => {
    return `linear-gradient(${angle}deg, ${from}, ${to})`;
  },
  shadows: {
    xs: `0px 1px 2px 0px ${hexToRgba("#101828", 0.05)}`,
    sm: `0px 1px 3px 0px ${hexToRgba("#101828", 0.1)}, 
         0px 1px 2px 0px ${hexToRgba("#101828", 0.06)}`,
    md: `0px 4px 8px -2px ${hexToRgba("#101828", 0.1)},
         0px 2px 4px -2px ${hexToRgba("#101828", 0.06)}`,
    lg: `0px 12px 16px -4px ${hexToRgba("#101828", 0.2)},
         0px 4px 6px -2px ${hexToRgba("#101828", 0.1)}`,
    xl: `0px 20px 24px -4px ${hexToRgba("#101828", 0.08)},
         0px 8px 8px -4px ${hexToRgba("#101828", 0.03)}`,
    xxl: `0px 24px 48px -12px ${hexToRgba("#101828", 0.18)}`,
    xxxl: `0px 32px 64px -12px ${hexToRgba("#101828", 0.14)}`,
    focus: (colour: string) => `0 0 0 4px ${hexToRgba(colour, 0.2)}`,
  },
  zIndex: {
    page: 1,
    surface: 50,
    overlay: 100,
    modal: 150,
  },
};

export type Colour = keyof typeof PESTheme.colours;
export type ColourPalette = {
  0: string;
  25: string;
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
};

export type ColourWeight = keyof ColourPalette;
